import { render, staticRenderFns } from "./ManageDetail.vue?vue&type=template&id=62d79bf8&scoped=true&"
import script from "./ManageDetail.vue?vue&type=script&lang=ts&"
export * from "./ManageDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d79bf8",
  null
  
)

export default component.exports